import type { FC } from 'react';

import { useCashierCallbackConnected } from '../../../hooks/useCashierCallbackConnected';
import { useBetSlice } from '../../../store/slices/bets/selectors';
import { useChatSlice } from '../../../store/slices/chat/selectors';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { useGameStateSlice } from '../../../store/slices/game/selectors';

import { MiniChat } from './MiniChat';

export const MiniChatConnected: FC = () => {
  const cashierCallback = useCashierCallbackConnected();

  const casinoId = useConfigSlice.session()?.casinoId ?? '';
  const userId = useConfigSlice.playerConfig()?.userId ?? '';
  const tableId = useConfigSlice.session()?.tableId ?? '';
  const currentUserId = useConfigSlice.playerConfig()?.userId ?? '';

  const isGameChatBlocked = useChatSlice.getIsGameChatBlocked();
  const messages = useChatSlice.getRecentMessages();

  const balance = useGameStateSlice.getDeductibleBalance();
  const isLowBalance = useBetSlice.isLowBalance(balance);
  const hasNoBets = useBetSlice.totalBet() === 0;

  const isChatDisabled = useConfigSlice.isChatDisabled();
  if (isChatDisabled) {
    return null;
  }

  return (
    <MiniChat
      cashierCallback={cashierCallback}
      casinoId={casinoId}
      currentUserId={currentUserId}
      isGameChatBlocked={isGameChatBlocked}
      isGameChatUnavailable={isLowBalance && hasNoBets}
      messages={messages}
      tableId={tableId}
      userId={userId}
    />
  );
};
